/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgDocumentIntelligenceBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.25 2H10.6C15.2392 2 19 5.92612 19 10.7692M10.25 2C11.9897 2 13.4 3.47229 13.4 5.28846V6.75C13.4 7.35539 13.8701 7.84615 14.45 7.84615H15.85C17.5897 7.84615 19 9.31845 19 11.1346V13.6923M10.25 2H6.05C5.4701 2 5 2.49076 5 3.09615V19.9038C5 20.5092 5.4701 21 6.05 21H6.86667M14 22L14.5257 20.423C14.8243 19.5272 15.5272 18.8243 16.423 18.5257L18 18L16.423 17.4743C15.5272 17.1757 14.8243 16.4728 14.5257 15.577L14 14L13.4743 15.577C13.1757 16.4728 12.4728 17.1757 11.577 17.4743L10 18L11.577 18.5257C12.4728 18.8243 13.1757 19.5272 13.4743 20.423L14 22Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgDocumentIntelligence = wrapIcon(SvgDocumentIntelligenceBase);
export default SvgDocumentIntelligence;
